var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-color-picker" } },
    [
      _c(
        "or-tooltip",
        {
          attrs: { content: _vm.$t("HITL.common.labels.reset-default-color") },
        },
        [
          _c("or-icon-button", {
            attrs: {
              "data-button": "base-color-picker-reset",
              disabled: _vm.isLoading || _vm.isDisabled,
              icon: "replay",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("reset")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "data-input": "base-color-picker-text-input",
          size: "s",
          "model-value": _vm.color,
          placeholder: _vm.COLOR_PLACEHOLDER,
          disabled: _vm.isLoading || _vm.isDisabled,
        },
        on: { input: _vm.onTextInput },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { disabled: _vm.isLoading || _vm.isDisabled, type: "color" },
        domProps: { value: _vm.color },
        on: {
          change: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }